/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML_forspeaker';
import update from 'react-addons-update'; // ES6

var _ = require('lodash');
import ReactTable from "react-table"
import "react-table/react-table.css"
import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.key;
function MyCell({ value }) {
  return <a href="#" >{value}1</a>
}
class Committee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",

      sectionsactive: ["active", ""],
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerdes: "",
      columns: [],
      tdata: [],
      updatedspeaker: false,
      selectedspeaker: {}
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";

    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }
  savetoreduxandfirebase() {
    var data = this.processdataforfirebase(this.state.treeData);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/infobooths").set(data);
    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'infobooths', data: data });
  }
  doedit(d) {
    console.log("in edit");
    var key = this.state.selectedspeaker.key;

    console.log(d);
    console.log("Update redux state");
    this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: d })
    console.log("Updating local state");
    this.setState({
      tdata: this.state.tdata.map(el => (el.key === key ? { ...el, ...d } : el))
    }, () => {
      console.log(this.state.tdata);
    });
    console.log("Saving to firebase");
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/" + key).update(d);

    this.gotomainlist();

  }
  doDelete() {
    console.log("Do delete ");
    console.log(this.state.selectedspeaker);
    var key = this.state.selectedspeaker.key;
    console.log("Update redux state");
    this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: undefined })
    console.log("Updating local state");
    this.setState({
      tdata: this.state.tdata.filter(el => (el.key === key ? false : true))
    }, () => {
      console.log(this.state.tdata);
    });
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/" + key).set(null);

    // this.setState({
    //   treeData: nodes
    // }, () => {
    //   console.log("DOne");
    //   console.log(this.state.treeData);
    //   this.savetoreduxandfirebase();
    // });
    this.refs.deleteDialog.hide()
  }


  cancelDelete() {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }


  getObjectDiff(obj1, obj2) {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key);
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key);
        result.splice(resultKeyIndex, 1);
      }
      return result;
    }, Object.keys(obj2));

    return diff;
  }
  processdataforfirebase(data) {
    var tracks = {};
    var infobooths = {};
    for (let index = 0; index < data.length; index++) {
      tracks[data[index].key] = {
        name: data[index].title,
        o: index
      }
      if (data[index].children) {
        for (let j = 0; j < data[index].children.length; j++) {
          var d = data[index].children[j];
          var infobooth = {};
          infobooth.name = d.title;
          infobooth.o = j;
          infobooth.des = d.des;
          infobooth.track = data[index].key;
          infobooths[d.key] = infobooth;
        }
      }
    }
    return { tracks: tracks, infobooth: infobooths };
  }


  sectionTabContent(treeData) {
    // var data = JSON.parse(JSON.stringify(treeData))
    return (
      <div style={{ padding: '50px' }}>
        <ReactTable
          data={this.state.tdata}
          columns={this.state.columns}
          sortable={true}
          multiSort={true}
          filterable={true}
          showPagination={false}
          defaultSorted={[
            {
              id: "name",
              desc: false
            }
          ]}
          defaultFilterMethod={(filter, row) => { return row[filter.id].toLowerCase().includes(filter.value.toLowerCase()) }}
        />
      </div>

    )
  }





  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerdes: "",
      selectedspeaker: {},
      updatedspeaker: false
    })
  }

  componentWillMount() {
    console.log("kkk");
    console.log(this.props)
    var columns = [
      {
        Header: 'Name',
        accessor: (row) => {
          if (row.name) {
            return row.name
          } else {
            return ""
          }
        },
        id: "name",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Post',
        // accessor: 'post',
        accessor: (row) => {
          if (row.post) {
            return row.post
          } else {
            return ""
          }
        },
        id: "post",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Company',
        accessor: (row) => {
          if (row.company) {
            return row.company
          } else {
            return ""
          }
        },
        id: "company",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Photo',
        accessor: (row) => {
          if (row.pic) {
            return row.pic
          } else {
            return ""
          }
        },
        id: "pic",
        maxWidth: 150,
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        Cell: ({ value }) => {
          if (value != "") {
            return <img src={value} className="roundedimage" />

          } else {
            return <img src="./assets/img/profile.jpg" className="roundedimage" />

          }
        },
      },
      {
        Header: 'Description',
        accessor: (row) => {
          if (row.des) {
            return row.des
          } else {
            return ""
          }
        },
        id: "des",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        Cell: ({ value }) => {
          return <div dangerouslySetInnerHTML={{ __html: value }} />
        },
      },
      {
        Header: 'Action',
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 100,
        Cell: row => {
          return (
            <div>
              <button className="btn-primary" onClick={() => {
                console.log(row.original);
                console.log("Edit clicked");
                this.setState({
                  updatedspeaker: true,
                  selectedspeaker: row.original,
                  speakername: row.original.name,
                  speakerpost: row.original.post,
                  speakercompany: row.original.company,
                  speakerimage: row.original.pic ? row.original.pic : "./assets/img/profile.jpg",
                  speakerdes: row.original.des,
                  sectionsactive: ["", "active"],
                })
              }
              }> <i className="material-icons">edit</i></button>
              <br /> <br />
              <button className="btn-danger" onClick={() => {
                console.log(row.original);
                console.log("Delte clicked");
                this.refs.deleteDialog.show();
                this.setState({
                  selectedspeaker: row.original
                })
              }
              }> <i className="material-icons">delete</i></button>
            </div>)
        },
      },
    ];
    if (this.props.events[this.props.params.sub]) {
      if (this.props.events[this.props.params.sub][this.props.route.type]) {
        if (this.props.events[this.props.params.sub][this.props.route.type]) {
          var speakerdata = JSON.parse(JSON.stringify(this.props.events[this.props.params.sub][this.props.route.type]));
        
        } else {
          var speakerdata = {};

        }
        var tdata = [];
        Object.keys(speakerdata).map(key => {
          var d = speakerdata[key];
          d['key'] = key
          tdata.push(d);
        })
        this.setState({
          tdata: tdata,
          columns: columns
        })
      } else {
        this.setState({
          columns: columns
        })
      }
    } else {
      this.setState({
        columns: columns
      })
    }

  }
  gotomainlist() {
    this.setState({
      sectionsactive: ["active", ""],
      selectedspeaker: {},
      speakername: "",
      speakerpost: "",
      speakerimage: "./assets/img/profile.jpg",
      speakercompany: "",
      speakerdes: ""
    })
  }
  addspeaker() {

    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <div className="form-group">
          <label>{T.td("Speaker Image")}</label>
          <Image
            parentKey="icon"
            options={{}}
            updateAction={(key, value) => {
              console.log(value);
              this.setState({
                speakerimage: value
              })
              // this.saveAppInfo("applist/" + this.props.params.sub + "/ai", value);
            }}
            class="roundedimage"
            theKey="icon"
            value={this.state.speakerimage} />
        </div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Speaker name")}</label>
            <input value={this.state.speakername} name="name" onChange={(event) => {
              this.setState({
                speakername: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />


        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">class</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Post")}
            </label>
            <input value={this.state.speakerpost} name="name" onChange={(event) => {
              this.setState({
                speakerpost: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">supervised_user_circle</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Company")}
            </label>
            <input value={this.state.speakercompany} name="name" onChange={(event) => {
              this.setState({
                speakercompany: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
        </div>
        <div className="input-group">

        </div>
        <br />


        <br />
        <div className="form-group">
          <label>{T.td("Speaker Description")}</label>
          <HTML theKey={"htmlkey"} value={this.state.speakerdes} updateAction={(data) => {
            this.setState({
              speakerdes: data
            })
          }}></HTML>

        </div>


        {/*<button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalCookie1">{T.td("Delete App")}</button>*/}
        <br /><br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" className="btn btn-primary"
            onClick={() => {
              console.log(this.state.speakername);
              console.log(this.state.speakerpost);
              console.log(this.state.speakercompany);
              console.log(this.state.speakerimage);
              console.log(this.state.speakerdes);
              console.log("Saving to database and redux");
              console.log(this.state.selectedspeaker);
              var d = {};
              d.name = this.state.speakername;
              d.post = this.state.speakerpost;
              d.company = this.state.speakercompany;
              if (this.state.speakerimage != "./assets/img/profile.jpg") {
                d.pic = this.state.speakerimage;
              }
              d.des = this.state.speakerdes;
              if (this.state.updatedspeaker) {
                console.log("Updating speaker");
                this.doedit(d);
              } else {
                console.log("add speaker");
                var speakercreate = firebase.app.database().ref("myapps/" + this.props.params.sub + "/" + this.props.route.type).push();
                var speakerkey = speakercreate.key;
                this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: speakerkey, data: d })
                speakercreate.set(d)
                d["key"] = speakerkey;
                this.setState({
                  tdata: [...this.state.tdata, d]
                });

                this.gotomainlist();
              }
              // var data = {
              //   login: this.state.applogin == "true" ? true : false,
              //   name: this.state.appname,
              //   sdate: this.state.appsdate,
              //   edate: this.state.appedate,
              //   place: this.state.applocation,
              //   layout: this.state.layout
              // }

              // this.props.updateappinfo({
              //   eventkey: this.props.params.sub, data: data
              // });
              // firebase.app.database().ref("applist/" + this.props.params.sub).update(data);
              // this.setState({
              //   dapplogin: this.state.applogin,
              //   dappname: this.state.appname,
              //   dappsdate: this.state.appsdate,
              //   dappedate: this.state.appedate,
              //   dapplocation: this.state.applocation,
              //   dlayout: this.state.layout
              // })
            }
            }
            // data-toggle="modal" 
            // data-target="#modalCookie1" 
            disabled={this.state.updatedspeaker ? ((this.state.speakername == this.state.selectedspeaker.name) && (this.state.speakerpost == this.state.selectedspeaker.post) && (this.state.speakercompany == this.state.selectedspeaker.company) && (this.state.speakerimage == this.state.selectedspeaker.pic) && (this.state.speakerdes == this.state.selectedspeaker.des) || !this.state.speakername) : !this.state.speakername}>
            {T.td(this.state.updatedspeaker ? "Update " + this.props.route.name : "Add " + this.props.route.name)}
          </button>
        </div>

      </div>)
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  render() {
    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td(this.capitalize(this.props.route.type)),
        active: this.state.sectionsactive[0],
        label1: T.ts(this.capitalize(this.props.route.type) + " List"),
        content: this.sectionTabContent(this.state.treeData)
      }, {
        name: "images",
        icon: "collections",
        title: T.td("Add " + this.props.route.name),
        active: this.state.sectionsactive[1],
        label1: T.td("Add " + this.props.route.name),
        content: this.addspeaker()
      }
    ];

    return (
      <div>
        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td(this.props.route.name + " name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.selectedspeaker.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>


          <Wizzard
            title={this.capitalize(this.props.route.type)}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />
        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updatedataobjectbytype: dispatch.eventmodel.updatedataobjectbytype,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Committee);


// WEBPACK FOOTER //
// ./src/containers/Builder/Committee.js